import * as React from 'react'
import { Site } from '@envato/foundation-types'

import FullWidthBannerBlock from '../../../components/categoryPage/fullWidthBannerBlock'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { ICommonLocation } from '../../../../common/utils/location/types'

import * as styles from './fullWidthBannerSection.module.css'

const fullWidthBannerData: any = {
  themeforest: {
    title: 'Save on best-selling themes & web templates',
    subtitle:
      'Unwrap selected WordPress themes, HTML and more. Limited time only!',
    buttonText: 'Go to sale',
    backgroundColor: '#035DD9',
    textColor: '#FFF',
    url: 'https://envato.com/c/birthday-sale/themes/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-08-tf.png',
      alt: 'Envato Birthday Sale 2020'
    },
    gaLabel: 'BirthdaySale_19Aug2020'
  },
  codecanyon: {
    title: 'Save on best-selling plugins & code',
    subtitle:
      'Unwrap selected WP plugins, PHP scripts and more. Limited time only!',
    buttonText: 'Go to sale',
    backgroundColor: '#035DD9',
    textColor: '#FFF',
    url: 'https://envato.com/c/birthday-sale/code/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-08-cc.png',
      alt: 'Envato Birthday Sale 2020'
    },
    gaLabel: 'BirthdaySale_19Aug2020'
  },
  videohive: {
    title: 'Save on best-selling video templates',
    subtitle:
      'Unwrap selected After Effects files, Premiere Pro templates and more. Limited time only!',
    buttonText: 'Go to sale',
    backgroundColor: '#035DD9',
    textColor: '#FFF',
    url: 'https://envato.com/c/birthday-sale/video/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-08-vh.png',
      alt: 'Envato Birthday Sale 2020'
    },
    gaLabel: 'BirthdaySale_19Aug2020'
  },
  audiojungle: {
    title: 'Save on best-selling audio tracks',
    subtitle: 'Unwrap selected royalty-free music and more. Limited time only!',
    buttonText: 'Go to sale',
    backgroundColor: '#035DD9',
    textColor: '#FFF',
    url: 'https://envato.com/c/birthday-sale/audio/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-08-aj.png',
      alt: 'Envato Birthday Sale 2020'
    },
    gaLabel: 'BirthdaySale_19Aug2020'
  },
  graphicriver: {
    title: 'Save on best-selling graphic templates',
    subtitle: 'Unwrap selected Photoshop actions and more. Limited time only!',
    buttonText: 'Go to sale',
    backgroundColor: '#035DD9',
    textColor: '#FFF',
    url: 'https://envato.com/c/birthday-sale/graphics/',
    image: {
      url:
        'https://assets.shopfront.envato-static.com/images/categories/sale-campaign-2020-08-gr.png',
      alt: 'Envato Birthday Sale 2020'
    },
    gaLabel: 'BirthdaySale_19Aug2020'
  }
}

const FullWidthBannerSection = ({
  makeSearchLink,
  currentSite,
  location,
  bgColor
}: {
  currentSite: Site
  location: ICommonLocation
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  bgColor: string
}) => {
  if (!fullWidthBannerData[currentSite]) {
    return null
  }
  return (
    <section
      className={styles.fullWidthBannerSectionWrapper}
      style={{ background: bgColor }}
    >
      <div className={styles.fullWidthBannerWrapper}>
        <FullWidthBannerBlock
          location={location}
          locationParams={{}}
          componentType="FullWidthBannerBlock"
          makeSearchLink={makeSearchLink}
          currentSite={currentSite}
          data={fullWidthBannerData[currentSite]}
        />
      </div>
    </section>
  )
}

export default FullWidthBannerSection
